import React from 'react'

const DropdownTableData = ({
	options,
	selectedOption,
	setSelectedOption,
	disabled,
}) => {
	const onInput = (e) => {
		setSelectedOption(e.target.value)
	}

	return (
		<td>
			<select
				value={!!selectedOption ? selectedOption : -1}
				onInput={onInput}
				disabled={disabled}
			>
				<option
					value={-1}
					disabled={true}
					style={{ display: !!selectedOption ? 'none' : 'default' }}
				>
					{' '}
					--Bitte Auswählen--
				</option>
				{options &&
					options.map((option) => (
						<option key={option['@id']} value={option['@id']}>
							{option.name}
						</option>
					))}
			</select>
		</td>
	)
}

export default DropdownTableData
